<script setup lang="ts"></script>

<template>
  <div
    class="container max-w-128 min-h-svh min-h-dvh flex flex-col justify-center items-stretch grow relative my-auto py-8">
    <slot/>
  </div>
</template>
